import React, { useEffect, useState, forwardRef } from "react";
import { TextField, Box } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format, parseISO } from "date-fns";

const dateStyle = {
  shrink: true,
  style: { fontSize: '12px' },
};

const RegistrationInput = forwardRef((props, ref) => {
  const { errorMessage, type, ...otherProps } = props;
  const [error, setError] = useState(false);

  useEffect(() => {
  }, [props.buttonPressed]);

  useEffect(() => {
    setError(errorMessage !== undefined);
  }, [errorMessage]);

  return (
    <Box
      sx={{
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        lineHeight: '40px',
        marginBottom: '7px',
        marginTop: '0px',
        paddingTop: "0px",
        paddingBottom: "0px",
      }}
    >
      {type === 'date' ? (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            {...otherProps}
            onChange={(newDate) => {
              if (newDate && !isNaN(newDate)) {
                props.setValue(props.name, newDate)
              }
            }}
            inputFormat="yyyy/MM/dd"
            slotProps={{
              textField: {
                InputLabelProps: {
                  shrink: true,
                  style: { 
                    fontSize: '12px',
                    color: props.buttonPressed && props.required && !props.value ? "red" : "inherit", 
                  },
                },
                sx: {
                  width: '100%',
                  borderRadius: '4px',
                  fontFamily: 'Inter',
                  fontSize: '12px',
                  background: 'white',
                  paddingTop: '0px',
                  paddingBottom: '0px',
                  marginBottom: '4px',
                  marginTop: '0px',
                  '& .MuiInputBase-root': {
                    maxHeight: '40px',
                    fontSize: '12px',
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor:
                      props.buttonPressed && props.required && !props.value
                        ? "red !important"
                        : "inherit !important",
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      ) : (
        <TextField
          ref={ref}
          {...otherProps}
          variant="outlined"
          InputLabelProps={type === 'date' ? dateStyle : { shrink: true, style: { fontSize: '12px' } }}
          error={error}
          sx={{
            width: "100%",
            borderRadius: "4px",
            fontFamily: "Inter",
            fontSize: "12px", 
            background: "white",
            paddingTop: "0px",
            paddingBottom: "0px",
            marginBottom: "4px",
            marginTop: "0px",
            '& .MuiInputBase-root': {
              maxHeight: "40px", 
              fontSize: "12px", 
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: (props.buttonPressed && props.required && props.value === "") || props.hasError ? "red" : "inherit",
            },
          }}
          style={{ paddingTop: "0px", paddingBottom: "0px" }}
        />
      )}
    </Box>
  );
});

export const EditInput = forwardRef((props, ref) => {
  const { errorMessage, name, onChange, value, type, ...otherProps } = props;
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(errorMessage !== undefined);
  }, [errorMessage]);


  // Convert the string "yyyy-MM-dd" into a Date object for the DatePicker
  let dateValue = null;
  if (type === 'date' && typeof value === 'string' && value) {
    dateValue = parseISO(value); // Convert "yyyy-MM-dd" to Date
  } else {
    dateValue = value || null; // If no value, keep null
  }

  return (
    <Box
      sx={{
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        lineHeight: '40px',
        marginBottom: '7px',
        marginTop: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
      }}
    >
      {type === 'date' ? (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            {...otherProps}
            value={dateValue}
            inputFormat="yyyy/MM/dd"
            onChange={(newDate) => {
              if (newDate && !isNaN(newDate)) {
                onChange(format(newDate, "yyyy-MM-dd"))
              }
            }}
            sx={{
              width: '100%',
              borderRadius: '4px',
              fontFamily: 'Inter',
              fontSize: '12px', // Reduced font size
              background: 'white',
              paddingTop: '0px',
              paddingBottom: '0px',
              marginBottom: '4px',
              marginTop: '0px',
              '& .MuiInputBase-root': {
                maxHeight: '40px',
                fontSize: '12px',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: error ? 'red' : 'inherit',
              },
            }}
            slotProps={{
              textField: {
                InputLabelProps: {
                  shrink: true, 
                  style: { 
                    fontSize: '12px',
                    color: props.buttonPressed && props.required && !props.value ? "red" : "inherit",  
                  },
                },
                sx: {
                  width: '100%',
                  borderRadius: '4px',
                  fontFamily: 'Inter',
                  fontSize: '12px', // Reduced font size
                  background: 'white',
                  paddingTop: '0px',
                  paddingBottom: '0px',
                  marginBottom: '4px',
                  marginTop: '0px',
                  '& .MuiInputBase-root': {
                    maxHeight: '40px',
                    fontSize: '12px',
                  },
                  // "& .MuiOutlinedInput-notchedOutline": {
                  //   borderColor:
                  //     props.required && !props.value
                  //       ? "red"
                  //       : "inherit",
                  // },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor:
                      props.buttonPressed && props.required && !props.value
                        ? "red !important"
                        : "inherit !important",
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      ) : (

        <TextField
        ref={ref}
        {...otherProps}
        variant="outlined"
        error={errorMessage}
        InputLabelProps={
          props.type === 'date'
            ? dateStyle
            : { shrink: true, style: { fontSize: '12px' } }
        }
        sx={{
          width: '100%',
          borderRadius: '4px',
          fontFamily: 'Inter',
          fontSize: '12px', // Reduced font size of input
          background: 'white',
          paddingTop: '0px',
          paddingBottom: '0px',
          marginBottom: '4px',
          marginTop: '0px',
          '& .MuiInputBase-root': {
            maxHeight: '40px', 
            fontSize: '12px', 
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: props.buttonPressed && props.required && props.value === "" ? "red" : "inherit",
          },
        }}
        style={{ paddingTop: '0px', paddingBottom: '0px' }}
        onChange={onChange}
      />
      )}
    </Box>
  );
});

export default RegistrationInput;
